(() => {
class MXTicker extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.mx-ticker__track');
    this.primaryList = this.querySelector('.mx-ticker__list:not([aria-hidden="true"])') || this.querySelector('.mx-ticker__list');
    this.toggle = this.querySelector('.mx-ticker__toggle');

    if (!this.track || !this.primaryList) return;

    this.toggleMotion = () => {
      const isPaused = this.dataset.paused !== 'true';

      this.dataset.paused = String(isPaused);
      this.toggle.setAttribute('aria-pressed', String(isPaused));
      this.toggle.textContent = isPaused ? 'Play animation' : 'Pause animation';
    };

    this.toggle?.addEventListener('click', this.toggleMotion);

    this.ensureCoverage = (distance) => {
      const requiredListCount = Math.max(2, Math.ceil((this.clientWidth + distance) / distance));
      let lists = this.track.querySelectorAll('.mx-ticker__list');

      while (lists.length > requiredListCount) {
        const generatedClone = Array.from(lists)
          .reverse()
          .find((list) => list.hasAttribute('data-mx-ticker-clone'));

        if (!generatedClone) break;
        generatedClone.remove();
        lists = this.track.querySelectorAll('.mx-ticker__list');
      }

      while (lists.length < requiredListCount) {
        const clone = this.primaryList.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.setAttribute('data-mx-ticker-clone', '');
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });
        this.track.appendChild(clone);
        lists = this.track.querySelectorAll('.mx-ticker__list');
      }
    };

    this.updateMotion = () => {
      const trackStyles = getComputedStyle(this.track);
      const gap = Number.parseFloat(trackStyles.columnGap) || 0;
      const distance = this.primaryList.getBoundingClientRect().width + gap;
      const speed = Number(this.dataset.speed) || 50;

      if (distance <= 0) return;

      this.ensureCoverage(distance);
      this.style.setProperty('--mx-ticker-offset', `${distance * -1}px`);
      this.style.setProperty('--mx-ticker-duration', `${distance / speed}s`);
    };

    this.resizeObserver = new ResizeObserver(this.updateMotion);
    this.resizeObserver.observe(this.primaryList);
    this.resizeObserver.observe(this);
    requestAnimationFrame(this.updateMotion);
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.toggleMotion);
    this.resizeObserver?.disconnect();
  }
}

if (!customElements.get('mx-ticker')) {
  customElements.define('mx-ticker', MXTicker);
}
})();
